import http from "../axios";

const basicsApi = {
    // 通过省市区获取学校列表
    getSchoolList(data){
        return http({
            url:'/Principal/GetSchools',
            method:'POST',
            data:data
        })
    },
    // 通过学校列表获取教师列表
    getTecList(data){
        return http({
            url:'/Principal/GetTeachers',
            method:'POST',
            data:data
        })
    },
    // 模糊查询教师
    getTec(data){
        return http({
            url:'/Principal/SearchTeacher',
            method:'POST',
            data:data
        })
    }
}

export default basicsApi